export default "__VITE_ASSET__DQ3U1pa3__"